import React from "react";
import { Navigate } from "react-router-dom";
import { ROLES, getUserRole } from "constants/roles";

const Authmiddleware = (props) => {
  if (!localStorage.getItem("authUser")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  // Role-based access: SUPER_ADMIN can reach everything; otherwise the route's
  // allowedRoles (when defined) must include the current role.
  const role = getUserRole();
  if (
    role !== ROLES.SUPER_ADMIN &&
    props.allowedRoles &&
    !props.allowedRoles.includes(role)
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
